import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, provideDefaultConfig } from '@spartacus/core';
import { AlertMessageModule } from '../../../../shared/components/alert-message';
import { OperationalMessageComponent } from './operational-message.component';

@NgModule({
  imports: [CommonModule, AlertMessageModule],
  declarations: [OperationalMessageComponent],
  exports: [OperationalMessageComponent],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        OperationalMessageComponent: {
          component: OperationalMessageComponent,
        },
      },
    }),
  ],
})
export class OperationalMessageModule {}
